var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_192",
    "data-name": "Grupo 192",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.924,
    height: 22.925,
    viewBox: "0 0 22.924 22.925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_119",
    "data-name": "Trazado 119",
    d: "M841.442,180.016a2.282,2.282,0,1,0,2.282,2.282A2.285,2.285,0,0,0,841.442,180.016Z",
    transform: "translate(-829.885 -170.836)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_120",
    "data-name": "Trazado 120",
    d: "M836.462,166a11.462,11.462,0,1,0,11.462,11.462A11.476,11.476,0,0,0,836.462,166Zm7.283,14.237a4.346,4.346,0,0,1-4.346,4.345h-5.736a4.345,4.345,0,0,1-4.346-4.345V174.5a4.345,4.345,0,0,1,4.346-4.345H839.4a4.346,4.346,0,0,1,4.346,4.345Z",
    transform: "translate(-825 -166)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_121",
    "data-name": "Trazado 121",
    d: "M842.392,174.422h-5.736a2.985,2.985,0,0,0-2.985,2.985v5.736a2.985,2.985,0,0,0,2.985,2.984h5.736a2.984,2.984,0,0,0,2.985-2.984v-5.736A2.985,2.985,0,0,0,842.392,174.422Zm-2.843,9.509a3.563,3.563,0,1,1,3.563-3.563A3.567,3.567,0,0,1,839.548,183.931Zm3.771-6.517a.848.848,0,1,1,.848-.848A.848.848,0,0,1,843.319,177.414Z",
    transform: "translate(-827.992 -168.906)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.db66719b0b28566685c03ee884628154.svg";
export { ForwardRef as ReactComponent };